import { createStore } from 'vuex'
import groups from '@/store/modules/groups'
import clients from '@/store/modules/clients'


export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    groups,
    clients
  }
})
